import React from 'react';
import { useContent } from './content';
import { Markdown } from './markdown';

const LEVEL_NAME: Record<number, string> = { 1: 'Not shown', 2: 'Limited', 3: 'Solid', 4: 'Strong', 5: 'Exemplary' };

/** "How you'll be scored": the rubric behind every debrief. */
export function RubricView() {
  const rubric = useContent()?.evaluationRubric ?? [];
  if (rubric.length === 0) return <p className="hint">The scoring rubric is not available yet.</p>;
  return (
    <div className="rubric">
      <p className="hint">{rubric.length} dimensions, each scored 1 (not shown) to 5 (exemplary).</p>
      {rubric.map((row, index) => (
        <article className="rubric-card" key={row.id}>
          <h3>{index + 1}. {row.dimension}</h3>
          <h4>What excellent looks like</h4>
          <Markdown citations={row.sources} source={row.whatExcellentLooksLike} />
          {row.evidenceToLookFor.length > 0 && (
            <>
              <h4>Evidence to look for</h4>
              <ul>{row.evidenceToLookFor.map((item, position) => <li key={position}>{item}</li>)}</ul>
            </>
          )}
          {row.anchors.length > 0 && (
            <div className="md-table-wrap">
              <table className="rubric-anchors">
                <thead><tr><th>Score</th><th>What it looks like</th></tr></thead>
                <tbody>
                  {row.anchors.map((anchor) => (
                    <tr key={anchor.level}>
                      <th scope="row">{anchor.level} · {LEVEL_NAME[anchor.level]}</th>
                      <td>{anchor.text}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {(row.sources.length > 0 || row.references.length > 0) && (
            <div className="section-refs">
              <h4>References</h4>
              <ol>
                {(row.sources.length > 0 ? row.sources.map((source) => ({ label: source.label, url: source.url })) : row.references.map((label) => ({ label, url: '' }))).map((ref, position) => (
                  <li key={position}>
                    {ref.url ? <a href={ref.url} rel="noopener noreferrer" target="_blank">{ref.label || ref.url}</a> : ref.label}
                  </li>
                ))}
              </ol>
            </div>
          )}
        </article>
      ))}
    </div>
  );
}

/** Collapsed by default; used under feedback. */
export function RubricDetails() {
  const [opened, setOpened] = React.useState(false);
  return (
    <details className="rubric-details" onToggle={(event) => setOpened(event.currentTarget.open)}>
      <summary>Scoring rubric — how this feedback is scored</summary>
      {opened && <RubricView />}
    </details>
  );
}
